<section class="saved-queries-panel">
    <!--
        Previous always-visible header (title button + separate collapse chevron), superseded in ticket 04
        by the single trigger below that also surfaces the active query's name. Kept here, inert, in case
        the popup shape gets reverted — restore this block and drop the trigger to go back.

        <div class="saved-queries-panel__header">
            <button
                type="button"
                class="saved-queries-panel__collapse"
                [attr.aria-expanded]="expanded()"
                (click)="toggleExpanded()"
            >
                <span class="saved-queries-panel__title">{{ "components.saved-queries.panel.title" | translate }}</span>
            </button>
            <button
                type="button"
                class="saved-queries-panel__toggle"
                [attr.aria-expanded]="expanded()"
                [attr.aria-label]="'components.saved-queries.panel.toggle' | translate"
                (click)="toggleExpanded()"
            >
                <svg
                    sh-icon
                    name="angle-down"
                    class="saved-queries-panel__chevron"
                    [class.saved-queries-panel__chevron--expanded]="expanded()"
                    aria-hidden="true"
                ></svg>
            </button>
        </div>
    -->

    <button
        type="button"
        class="saved-queries-panel__trigger"
        [attr.aria-expanded]="expanded()"
        [attr.aria-label]="'components.saved-queries.panel.toggle' | translate"
        (click)="toggleExpanded()"
    >
        <svg sh-icon name="search" class="saved-queries-panel__trigger-icon" aria-hidden="true"></svg>
        <span class="saved-queries-panel__trigger-label" [attr.title]="activeQuery()?.Name ?? null">
            {{
                activeQuery()
                    ? ("components.saved-queries.panel.active" | translate: { name: activeQuery()!.Name })
                    : ("components.saved-queries.panel.title" | translate)
            }}
        </span>
        <svg
            sh-icon
            name="angle-down"
            class="saved-queries-panel__chevron"
            [class.saved-queries-panel__chevron--expanded]="expanded()"
            aria-hidden="true"
        ></svg>
    </button>

    <div class="saved-queries-panel__actions">
        <button
            type="button"
            class="saved-queries-panel__save"
            [disabled]="!canSaveQuery()"
            [attr.title]="!canSaveQuery() ? ('components.saved-queries.disabled.save' | translate) : null"
            (click)="requestSave()"
        >
            <svg sh-icon name="plus" class="saved-queries-panel__save-icon" aria-hidden="true"></svg>
            {{ "components.saved-queries.actions.save" | translate }}
        </button>

        @if (canUpdateQuery() && activeQuery()?.Context?.IsEditable) {
            <button type="button" class="saved-queries-panel__save saved-queries-panel__update" (click)="requestUpdate()">
                <svg sh-icon name="rotate-clockwise" class="saved-queries-panel__save-icon" aria-hidden="true"></svg>
                {{ "components.saved-queries.actions.update" | translate }}
            </button>
        }
    </div>

    @if (expanded()) {
        <button
            type="button"
            class="saved-queries-panel__backdrop"
            [attr.aria-label]="'components.saved-queries.panel.close' | translate"
            (click)="toggleExpanded()"
        ></button>

        <div class="saved-queries-panel__popup" role="dialog" [attr.aria-label]="'components.saved-queries.panel.title' | translate">
            @if (hasError()) {
                <p class="saved-queries-panel__empty">
                    {{ "components.saved-queries.overview.messages.failed-to-fetch" | translate }}
                </p>
            } @else if (queries()) {
                <!--
                    Ticket 02's mine/shared tabs + row list, superseded in ticket 06 by the flat
                    `sh-form-multi-select` below (same select the load-saved-query dialog uses, with a
                    "(gedeeld)" suffix per row instead of a tab). Kept here in case the tabs come back.

                    <div class="saved-queries-panel__tabs" role="tablist">
                        <button
                            type="button"
                            class="saved-queries-panel__tab"
                            [class.saved-queries-panel__tab--active]="activeTab() === 'mine'"
                            role="tab"
                            [attr.aria-selected]="activeTab() === 'mine'"
                            (click)="setTab('mine')"
                        >
                            {{ "components.saved-queries.panel.tabs.mine" | translate }} ({{ mine().length }})
                        </button>
                        <button
                            type="button"
                            class="saved-queries-panel__tab"
                            [class.saved-queries-panel__tab--active]="activeTab() === 'shared'"
                            role="tab"
                            [attr.aria-selected]="activeTab() === 'shared'"
                            (click)="setTab('shared')"
                        >
                            {{ "components.saved-queries.panel.tabs.shared" | translate }} ({{ shared().length }})
                        </button>
                    </div>

                    @if (visible().length) {
                        <ul class="saved-queries-panel__list">
                            @for (query of visible(); track query.Id) {
                                <li>
                                    <button
                                        type="button"
                                        class="saved-queries-panel__row"
                                        [class.saved-queries-panel__row--active]="query.Id === activeQueryId()"
                                        [attr.title]="query.Name"
                                        (click)="selectQuery(query)"
                                    >
                                        {{ query.Name }}
                                    </button>
                                </li>
                            }
                        </ul>
                    } @else {
                        <p class="saved-queries-panel__empty">
                            {{
                                (activeTab() === "mine"
                                    ? "components.saved-queries.panel.empty.mine"
                                    : "components.saved-queries.panel.empty.shared"
                                ) | translate
                            }}
                        </p>
                    }
                -->

                @if (queries()!.length) {
                    <sh-form-multi-select
                        [id]="'saved-queries-panel-select'"
                        [placeholderMsg]="'components.saved-queries.load-saved-query-dialog.select-query' | translate"
                        [searchPlaceholderMsg]="'components.saved-queries.load-saved-query-dialog.search-placeholder' | translate"
                        [listCappedMsg]="'components.saved-queries.load-saved-query-dialog.capped-results' | translate"
                        [noResultsFoundMsg]="'components.saved-queries.load-saved-query-dialog.no-results' | translate"
                        [control]="querySelectControl"
                        [options]="selectOptions()"
                        [search]="true"
                        [inOverflownContainer]="true"
                    ></sh-form-multi-select>
                } @else {
                    <p class="saved-queries-panel__empty">
                        {{ "components.saved-queries.panel.empty.none" | translate }}
                    </p>
                }

                @if (totalCount()) {
                    <a class="saved-queries-panel__view-all" routerLink="/saved-queries">
                        {{ "components.saved-queries.panel.view-all" | translate }} ({{ totalCount() }})
                    </a>
                }
            }
        </div>
    }
</section>
